import styles from './ProgressBar.module.css'

const ProgressBar = ({progress, allProgress, lvl}: {progress: number, allProgress: number, lvl?: number}) => {
    return (
        <div className={styles.inventoryProgressBar}>
            <div className={styles.inventoryProgressBarFill}
                style={{ width: `${progress / allProgress * 100}%` }}>
            </div>
            <span className={styles.progressText}>{progress}/{allProgress}</span>
        </div>
    )
}

export default ProgressBar